// Persistence for the dashboard's Resolution Engine session (email +
// password → JWT). Entirely separate from the Zoom OAuth session in
// lib/auth.ts, which stays dedicated to the in-meeting sidebar.

import type { Principal } from '../types/dashboard';

const STORAGE_KEY = 'keel_dashboard_session';

export interface DashboardSession {
  token: string;
  /** Epoch ms after which the JWT is expired. */
  expiresAt: number;
  principal: Principal;
}

export function loadDashboardSession(): DashboardSession | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as DashboardSession;
    if (!parsed.token || !parsed.principal) return null;
    if (parsed.expiresAt && parsed.expiresAt <= Date.now()) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveDashboardSession(session: DashboardSession): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch {
    /* private-mode storage failures degrade to session-only auth */
  }
}

export function clearDashboardSession(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
